import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa';
import logo from '../assets/images/logo.png';
import './Home.css';

const tabData = [
  {
    label: 'What We Do',
    content: (
      <ul style={{ paddingLeft: '1.2em', margin: 0 }}>
        <li>Importers & Distributors of RISEONIC Compatible Printer Cartridges</li>
        <li>Suppliers of Cartridge Components & Printer Parts through a dealer network</li>
        <li>Nationwide Support (Pan India)</li>
        <li>Managed Print Services (MPS) & Printer/Laptop Rentals</li>
        <li>Barcode Solutions: Printers, Scanners, Labels & Stickers</li>
        <li>IT Hardware Supplies: Monitors, Batteries, Adapters, RAM, SSDs, Power Stations, Stabilizers, Keyboards, Mice & more</li>
      </ul>
    ),
    image: require('../assets/images/whatwedo.jpeg'),
  },
  {
    label: 'Benefits of Working With Us',
    content: (
      <ul style={{ paddingLeft: '1.2em', margin: 0 }}>
        <li>One-Stop Solution for all IT product requirements</li>
        <li>Uniform Rate Contracts across branches to ensure IT standardization</li>
        <li>MPS Advantage: Printers become client assets post-contract</li>
        <li>Zero AMC Costs – No extra spending on printer maintenance</li>
        <li>Dedicated SPOC for seamless Pan India coordination</li>
        <li>Smart Decision Support for branch-level IT needs</li>
        <li>Structured Escalation Matrix for prompt issue resolution</li>
        <li>No Vendor Hassles – We streamline all IT coordination</li>
      </ul>
    ),
    image: require('../assets/images/benefits.png'),
  },
  {
    label: 'Our Vision',
    content: (
      <ul style={{ paddingLeft: '1.2em', margin: 0 }}>
        <li><strong>Our Vision</strong><br/>To make high-quality, premium IT products and services accessible to every household—integrating technology into everyday life at an affordable cost.</li>
        <li><strong>Our Approach</strong><br/>We foster innovation, reflective thinking, and adaptability, ensuring our solutions remain client-centric and impactful.</li>
        <li><strong>Our Commitment</strong><br/>We operate with transparency and integrity, making every decision to enhance the long-term value of our organization and those we serve.</li>
      </ul>
    ),
    image: require('../assets/images/vision.png'),
  },
];

const industries = [
  {
    name: 'Plastic & Chemical',
    image: require('../assets/images/industry-plastic.jpg'),
  },
  {
    name: 'Healthcare & Pharmaceuticals',
    image: require('../assets/images/industry-pharma.jpg'),
  },
  {
    name: 'Production & Film Industry',
    image: require('../assets/images/industry-film.png'),
  },
  {
    name: 'Hospitality & FMCG',
    image: require('../assets/images/industry-hospitality.jpg'),
  },
  {
    name: 'Manufacturing & Engineering',
    image: require('../assets/images/industry-manufacturing.webp'),
  },
  {
    name: 'Water Treatment',
    image: require('../assets/images/industry-water.jpg'),
  },
];

const carouselImages = [
  require('../assets/images/cartridge1.jpeg'),
  require('../assets/images/ink3.jpeg'),
  require('../assets/images/itproducts1.jpg'),
  require('../assets/images/itproducts-2.avif'),
  require('../assets/images/itproducts3.jpg'),
  require('../assets/images/itproducts4.png'),
  require('../assets/images/cartridge3.jpeg'),
  require('../assets/images/printer3.jpeg'),
  require('../assets/images/networkingequipment.jpeg'),
  require('../assets/images/peripherals-communication.jpeg'),
  require('../assets/images/Power-Memory-Accessories.jpeg'),
  require('../assets/images/printer4.jpeg'),
];

const Home = () => {
  // Tab state
  const [activeTab, setActiveTab] = useState(0);
  const [fade, setFade] = useState(true);
  const navigate = useNavigate();
  const [industriesAnimated, setIndustriesAnimated] = useState(false);
  const industriesRef = useRef(null);
  const columns = 3;
  const quickHighlightsRef = useRef(null);
  const [quickHighlightsInView, setQuickHighlightsInView] = useState(false);
  const [tabAnimation, setTabAnimation] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (!industriesRef.current) return;
      const rect = industriesRef.current.getBoundingClientRect();
      const triggerPoint = window.innerHeight * 0.9;
      if (rect.top < triggerPoint) {
        setIndustriesAnimated(true);
      } else {
        setIndustriesAnimated(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const observer = new window.IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setQuickHighlightsInView(true);
          }
        });
      },
      { threshold: 0.2 }
    );
    if (quickHighlightsRef.current) {
      observer.observe(quickHighlightsRef.current);
    }
    return () => observer.disconnect();
  }, []);

  // Handle tab change with fade effect and animation
  const handleTabClick = (idx) => {
    if (idx !== activeTab) {
      setFade(false);
      setTabAnimation(false);
      setTimeout(() => {
        setActiveTab(idx);
        setFade(true);
        setTabAnimation(true);
      }, 200);
    }
  };

  useEffect(() => {
    if (quickHighlightsInView) {
      setTabAnimation(true);
    }
  }, [quickHighlightsInView]);

  return (
    <div className="home-page">
      {/* First Page - Hero Section */}
      <section className="hero-section">
        <div className="home-container">
          <div className="home-content">
            <div className="logo-section">
              <div className="logo">
                <img src={logo} alt="ImageTech Logo" className="logo-image" loading="lazy" />
              </div>
            </div>
            <div className="text-section">
              <h2>Print with Confidence. Powered by RISEONIC.</h2>
              <p>
              
              Image Technology brings you dependable imaging solutions backed by years of industry expertise. With our own RISEONIC brand of compatible toner cartridges, we're setting new standards in quality and affordability.
              </p>
              <div className="cta-buttons">
                <button className="btn-primary" onClick={() => navigate('/contact')}>Get Started</button>
                <button className="btn-secondary" onClick={() => navigate('/about')}>Learn More</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Product Carousel Section */}
      <section className="carousel-section">
        <div className="carousel-container">
          <div className="carousel-header">
            <h2>Our Products</h2>
            <p>Discover our innovative image technology solutions</p>
          </div>
          <div className="carousel-wrapper">
            <div className="carousel-track">
              {carouselImages.map((image, index) => (
                <div key={`first-${index}`} className="carousel-item">
                  <img src={image} alt={`Product ${index + 1}`} className="carousel-image-real" loading="lazy" />
                </div>
              ))}
              {carouselImages.map((image, index) => (
                <div key={`second-${index}`} className="carousel-item">
                  <img src={image} alt={`Product ${index + 1}`} className="carousel-image-real" loading="lazy" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Third Page - Quick Trust Highlights Section */}
      <section className="trust-section">
        <div className="home-container">
          <div className="trust-header">
            <h2>Why Choose Image Technology?</h2>
            <p>Building trust through proven expertise and reliable service</p>
          </div>
          <div className="trust-content">
            <div className="trust-item">
              <div className="trust-icon">
                <img src={require('../assets/icon/wrench-alt.png')} alt="Expertise" style={{width:'48px',height:'48px'}} />
              </div>
              <div className="trust-text">
                <h3>25+ Years Expertise</h3>
                <p>Led by Industry Veteran Mr. Bharat A. Patel</p>
              </div>
            </div>
            <div className="trust-item">
              <div className="trust-icon">
                <img src={require('../assets/icon/building.png')} alt="Corporates" style={{width:'48px',height:'48px'}} />
              </div>
              <div className="trust-text">
                <h3>Trusted by Corporates</h3>
                <p>Dealer Network across Maharashtra</p>
              </div>
            </div>
            <div className="trust-item">
              <div className="trust-icon">
                <img src={require('../assets/icon/security.png')} alt="Most Trusted" style={{width:'48px',height:'48px'}} />
              </div>
              <div className="trust-text">
                <h3>Most Trusted</h3>
                <p>Preferred partner for reliability and customer satisfaction</p>
              </div>
            </div>
            <div className="trust-item">
              <div className="trust-icon">
                <img src={require('../assets/icon/shipping-fast.png')} alt="Fast Delivery" style={{width:'48px',height:'48px'}} />
              </div>
              <div className="trust-text">
                <h3>Fast Delivery</h3>
                <p>Within Promised Time Frame</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Fourth Page - Interactive Tabs Section */}
      <section className="tabs-section">
        <div className="home-container">
          <div className="tabs-header">
            <h2>Quick Highlights</h2>
            <p style={{ color: '#555', fontSize: '1.2rem', opacity: 0.9, maxWidth: 600, margin: '0 auto' }}>
              Building trust through proven expertise and reliable service
            </p>
            <hr style={{ border: 'none', borderTop: '1px solid #e0e0e0', margin: '1.2rem auto 1.5rem auto', maxWidth: 600 }} />
          </div>
          <div className="tabs-options improved-tabs">
            {tabData.map((tab, idx) => (
              <button
                key={tab.label}
                className={`tab-btn improved-tab-btn${activeTab === idx ? ' active' : ''}`}
                onClick={() => handleTabClick(idx)}
              >
                <span className="tab-label">{tab.label}</span>
                {activeTab === idx && <span className="tab-indicator" />}
              </button>
            ))}
          </div>
          <div
            className={`tabs-content-card${fade ? ' fade-in' : ' fade-out'}${quickHighlightsInView && tabAnimation ? ' quick-highlights-animate' : ''}`}
            ref={quickHighlightsRef}
          >
            <div className="tabs-content-row improved-content-row">
              <div className={`tabs-content-text improved-content-text${quickHighlightsInView && tabAnimation ? ' slide-in-left' : ''}`}> 
                <h3>{tabData[activeTab].label}</h3>
                <p>{tabData[activeTab].content}</p>
              </div>
              <div className={`tabs-content-image improved-content-image${quickHighlightsInView && tabAnimation ? ' slide-in-right' : ''}`}> 
                <div className="tabs-image-placeholder improved-image-placeholder">
                  <img src={tabData[activeTab].image} alt={tabData[activeTab].label} style={{width:'100%',height:'100%',objectFit:'cover',borderRadius:'12px'}} loading="lazy" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Fifth Page - Industries We Serve Section */}
      <section className="industries-section">
        <div className="home-container">
          <div className="industries-header">
            <h2>Industries Relying on Our Customized Printing Services</h2>
            <p>We proudly serve a diverse range of industries across India with tailored printing solutions.</p>
          </div>
          <div
            className={`industries-grid${industriesAnimated ? ' industries-animated' : ' industries-stacked'}`}
            ref={industriesRef}
          >
            {industries.map((industry, idx) => {
              const row = Math.floor(idx / columns);
              const col = idx % columns;
              return (
                <div
                  className="industry-card"
                  key={industry.name}
                  style={{
                    '--i': idx,
                    '--row': row,
                    '--col': col,
                    '--columns': columns,
                    '--total': industries.length
                  }}
                >
                  <div className="industry-image">
                    <img src={industry.image} alt={industry.name} className="industry-img-real" loading="lazy" />
                  </div>
                  <div className="industry-label">{industry.name}</div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home; 